import { render, staticRenderFns } from "./ConsultDetails.vue?vue&type=template&id=417505d9"
import script from "./ConsultDetails.vue?vue&type=script&lang=js"
export * from "./ConsultDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports